module.exports = __webpack_public_path__ + "/images/3b6ff68c19b4d71c914bf68c1b21ff8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/logo.png
// module id = 581
// module chunks = 0